/**
 * Dispara download de URL presignada (S3) sem XHR.
 * Axios/fetch no bucket exigem CORS; navegação top-level não.
 */
export const downloadPresignedUrl = (url) => {
  if (!url || typeof document === 'undefined') return;
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
